import { appGetState } from 'legacy/lut/store'

import { IFilter } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IGpRollupLongTerms } from '../models/gpRollupLongTerms'

export const fetchGPLongTermsRollup = async (filter: IDataProviderFilter) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGPLongTermStrategiesRollup/call`)

  const filters = filter.filters as IFilter[]
  const globalPartnerId = filters.find((it) => it.field === 'GlobalPartnerId')?.value
  const fYear = filters.find((it) => it.field === 'FYear')?.value
  const filtersValue = filters.find((it) => it.field === 'Filters')?.value
  const programType = filters.find((it) => it.field === 'ProgramType')?.value

  if (globalPartnerId && fYear) {
    const payload = {
      'p.GlobalPartnerId': globalPartnerId,
      'p.FYear': fYear,
      'p.Filters': filtersValue,
      'p.ProgramType': programType,
    }

    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response: { Data: IGpRollupLongTerms[] } = await Rest.post({
        url,
        payload,
        headers,
      })

      return {
        Data: response.Data.map((original, i, arr) => ({
          ...original,
          hasChildren: arr.some((it) => it.ParentId === original.EntryId),
        })),
      }
    } catch (e) {
      return {
        Data: [],
      }
    }
  }

  return { Data: [] }
}
